import { Box, Typography, Switch } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { handleSetMapType } from "../../store/actions/uiActions/myPermitsActions";
import React from "react";

const MapTypeSwitch = ({ additionalPermitNeedSetup }) => {
  const { mapSatellite, showMap } = useSelector(
    (state) => state.myPermitsComponent.duvalMap
  );

  const dispatch = useDispatch();

  const onChange = (event) => {
    const isChecked = event.target.checked;

    const payload = isChecked
      ? { mapSatellite: true, mapType: "hybrid" }
      : { mapSatellite: false, mapType: "streets-navigation-vector" };

    dispatch(handleSetMapType(payload));
  };
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography fontWeight="bold" variant="body2">
        Standard
      </Typography>
      <Switch
        disabled={additionalPermitNeedSetup ? false : !showMap}
        checked={mapSatellite}
        onChange={onChange}
      />
      <Typography fontWeight="bold" variant="body2">
        Satellite
      </Typography>
    </Box>
  );
};

export default React.memo(MapTypeSwitch);
